
import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {Service} from '../../service/service.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {BaseComponent} from '../basecomponent.js';

/* global customElements */
class PagingToolbar extends BaseComponent {
	
	static get properties() {
		return {
			currentPage: {type: Number},
			pageSize: {type: Number},
			totalRecords: {type: Number},
			showTotal: {type: Boolean}
		};
	}
	
	constructor() {
		super();
		
		var pagingToolbar = this;
		
		pagingToolbar.currentPage = 1;
		pagingToolbar.pageSize = 100;			
		pagingToolbar.totalPages = 1;
		pagingToolbar.showTotal = true;
		pagingToolbar.totalRecords = 0;
		
		setTimeout(function(){
			pagingToolbar.init();
		});
	}
	
	render() {	
		return html`
			<style>
				.toolbar {
					width: 100%;
					display: flex;
					flex-wrap: wrap;
					align-items: center;
					gap: 8px;
				}
		
				.status {
					margin-left: auto;
				}
		
				.status-text {
					margin-right: 20px;
					color: grey;
					position: static;
				}

				@media only screen and (max-width: 1024px) {
					.status {
						margin-left: 0;
						width: 100%;
					}
				}
		
			</style>
			<div class="toolbar">
				<span>
					<slot name="pager"></slot>
				</span>
				<span>
					<slot name="export"></slot>
				</span>
				<span class="status status-text">
					<slot name="status"></slot>
				</span>
			</div>
		`;
	}
	
	init() {
		var pagingToolbar = this;
		
		pagingToolbar.pager = ElementUtil.create({
			tag: 'span',
			slot: 'pager',
			children: [
				{
					tag: 'vaadin-button',
					itemid: 'firstPage',
					theme: 'icon tertiary',
					title: 'First Page',
					style: 'cursor: pointer;',
					disabled: true,
					children: [
						{
							tag: 'vaadin-icon',
							icon: 'lumo:chevron-left',
							slot: 'prefix'							
						}
					],
					listeners: {
						click: function() {
							pagingToolbar.loadPage(1);
						}
					}
				},
				{
					tag: 'vaadin-button',
					itemid: 'previousPage',
					theme: 'icon tertiary',
					title: 'Previous Page',
					style: 'cursor: pointer;',
					disabled: true,
					children: [
						{
							tag: 'vaadin-icon',
							icon: 'vaadin:chevron-left-small',
							slot: 'prefix'							
						} 
					],
					listeners: {
						click: function() {
							pagingToolbar.currentPage--;
							pagingToolbar.loadPage(pagingToolbar.currentPage);
						}
					}
				},
				{
					tag: 'span',
					style: 'margin-top: 15px;margin-left: 5px;margin-right: 5px;',
					innerHTML: 'Page '
				},
				{
					tag: 'vaadin-number-field',
					itemid: 'pageinput',
					style: 'width: 50px',
					value: pagingToolbar.currentPage,
					min: 1,					
					listeners: {
						blur: function(event) {
							this.value = pagingToolbar.currentPage;
						},
						keydown: function(event) {	
							if (event.key === 'Enter') {
								if (this.value > pagingToolbar.totalPages) {
									pagingToolbar.currentPage = pagingToolbar.totalPages;									
								} else if (this.value < 1) {
									pagingToolbar.currentPage = 1;
								} else {
									pagingToolbar.currentPage = this.value;
								}
								this.value = pagingToolbar.currentPage;
								pagingToolbar.loadCurrentPage();
							}
						}
					}
				},
				{
					tag: 'span',
					itemid: 'total',
					style: 'margin-top: 15px;margin-left: 5px;margin-right: 5px;',
					innerHTML: ' of ' + pagingToolbar.totalPages
				},
				{
					tag: 'vaadin-button',
					itemid: 'next',
					theme: 'icon tertiary',
					title: 'Next Page',
					style: 'cursor: pointer;',
					disabled: true,
					children: [
						{
							tag: 'vaadin-icon',
							icon: 'vaadin:chevron-right-small',
							slot: 'prefix'
						}
					],
					listeners: {
						click: function() {
							pagingToolbar.currentPage++;
							pagingToolbar.loadPage(pagingToolbar.currentPage);
						}
					}							
					
				},
				{
					tag: 'vaadin-button',
					itemid: 'last',
					theme: 'icon tertiary',
					title: 'Last Page',
					style: 'cursor: pointer;',
					disabled: true,
					children: [
						{
							tag: 'vaadin-icon',
							icon: 'lumo:chevron-right',
							slot: 'prefix'														
						}
					],
					listeners: {
						click: function() {
							pagingToolbar.loadPage(pagingToolbar.totalPages);
						}
					}
				}				
			]
		});
		pagingToolbar.append(pagingToolbar.pager);
		
		if (pagingToolbar.showTotal) {						
			pagingToolbar.status = ElementUtil.create({
				tag: 'span',
				itemid: 'totalStatus',
				slot: 'status',
				'class': 'status-text',
				innerHTML: pagingToolbar.recordDisplay()
			});
			pagingToolbar.append(pagingToolbar.status);
		}
		
		var readyEvent = new CustomEvent('ready', { detail: '' });
		pagingToolbar.dispatchEvent(readyEvent);		
	}
	
	recordDisplay() {
		var pagingToolbar = this;
		
		var startRange = 0;
		var endRange = 0;
		if (pagingToolbar.currentPage === 1 && pagingToolbar.totalRecords > 0) {
			startRange = 1;
		} 
		if (pagingToolbar.currentPage > 1) {
			startRange = ((pagingToolbar.currentPage * pagingToolbar.pageSize) - pagingToolbar.pageSize);
		}

		if (pagingToolbar.currentPage === 1) {
			endRange = pagingToolbar.pageSize;
		}
		if (pagingToolbar.currentPage > 1) {
			endRange = (pagingToolbar.currentPage * pagingToolbar.pageSize);
		}

		if (endRange > pagingToolbar.totalRecords) {
			endRange = pagingToolbar.totalRecords;
		}
		
		return 'Displaying ' + startRange + ' - ' + endRange + ' of ' + pagingToolbar.totalRecords;
	}
	
	hasNext() {
		var pagingToolbar = this;
		return pagingToolbar.currentPage < pagingToolbar.totalPages;
	}
	
	hasPrevious() {
		var pagingToolbar = this;
		return pagingToolbar.currentPage > 1;
	}
	
	pullRange() {
		var pagingToolbar = this;
		
		var pageRange = {
			offset: (pagingToolbar.currentPage-1) * pagingToolbar.pageSize,
			max: pagingToolbar.pageSize			
		};	
		return pageRange;		
	}
	
	loadCurrentPage() {
		var pagingToolbar = this;
		pagingToolbar.loadPage(pagingToolbar.currentPage);
	}
	
	loadPage(pageNumber) {
		var pagingToolbar = this;
		
		if (pageNumber > pagingToolbar.totalPages) {
			pageNumber = pagingToolbar.totalPages;
		}
		if (pageNumber < 1) {
			pageNumber = 1;
		}
		
		if (pagingToolbar.loader) {
			if (pagingToolbar.grid) {								
				pagingToolbar.currentPage = pageNumber;				
				//async 
				pagingToolbar.loader(pagingToolbar.grid, pageNumber, pagingToolbar);							
			} else {
				console.error('Grid must be set. element.grid = grid');
			}
		} else {
			console.error('loader function must be set. element.loader = loader');
		}
				
	}
	
	updatePager() {
		var pagingToolbar = this;
		
		pagingToolbar.totalPages = Math.ceil(pagingToolbar.totalRecords / pagingToolbar.pageSize);

		if (pagingToolbar.totalPages === 0) {
			pagingToolbar.totalPages = 1;
		}

		if (pagingToolbar.currentPage > pagingToolbar.totalPages) {
			pagingToolbar.currentPage = pagingToolbar.totalPages;
		}

		if (pagingToolbar.currentPage > 1) {
			ElementUtil.query(pagingToolbar.pager, 'firstPage').disabled = false;
			ElementUtil.query(pagingToolbar.pager, 'previousPage').disabled = false;
		} else {
			ElementUtil.query(pagingToolbar.pager, 'firstPage').disabled = true;
			ElementUtil.query(pagingToolbar.pager, 'previousPage').disabled = true;
		}

		if (pagingToolbar.currentPage === pagingToolbar.totalPages) {
			ElementUtil.query(pagingToolbar.pager, 'next').disabled = true;
			ElementUtil.query(pagingToolbar.pager, 'last').disabled = true;
		} else {
			ElementUtil.query(pagingToolbar.pager, 'next').disabled = false;
			ElementUtil.query(pagingToolbar.pager, 'last').disabled = false;
		}
		ElementUtil.query(pagingToolbar.pager, 'pageinput').value = pagingToolbar.currentPage;		
		ElementUtil.query(pagingToolbar.pager, 'total').innerHTML = ' of ' + pagingToolbar.totalPages;
		pagingToolbar.status.innerHTML = pagingToolbar.recordDisplay();
		
	}
	
};
customElements.define('dl-paging-toolbar', PagingToolbar);


